import { useRef } from 'react';
import { useBlocker } from 'react-router-dom';

type BlockLocation = {
  pathname: string;
  search?: string;
};

type HistoryBlockCallback = (
  location: BlockLocation,
  action?: string
) => boolean | void;

/** React Router v7 replacement for `history.block()`. */
export const useHistoryBlock = (callback: HistoryBlockCallback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useBlocker(({ currentLocation, nextLocation }) => {
    if (
      currentLocation.pathname === nextLocation.pathname &&
      currentLocation.search === nextLocation.search
    ) {
      return false;
    }

    return (
      callbackRef.current(
        {
          pathname: nextLocation.pathname,
          search: nextLocation.search,
        },
        'PUSH'
      ) === false
    );
  });
};
